var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import firebase from 'firebase';
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
let AuthModule = class AuthModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = [];
        this.user = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    /**
     * Get current user object
     * @returns User
     */
    get currentUser() {
        return this.user;
    }
    /**
     * Verify user authentication
     * @returns boolean
     */
    get isUserAuthenticated() {
        return this.isAuthenticated;
    }
    /**
     * Get authentification errors
     * @returns array
     */
    get getErrors() {
        return this.errors;
    }
    [_a = Mutations.SET_ERROR](error) {
        this.errors = error;
    }
    [_b = Mutations.SET_AUTH](data) {
        this.isAuthenticated = true;
        this.user = data.user;
        this.errors = [];
        localStorage.setItem('token', data.user.idToken);
        JwtService.saveToken(data.auth.access_token);
    }
    [_c = Mutations.SET_USER](user) {
        this.user = user;
    }
    [_d = Mutations.SET_PASSWORD](password) {
        this.user.password = password;
    }
    [_e = Mutations.PURGE_AUTH]() {
        this.isAuthenticated = false;
        this.user = {};
        this.errors = [];
        JwtService.destroyToken();
    }
    [_f = Actions.LOGIN](credentials) {
        return new Promise((resolve, reject) => {
            // firebase.auth().signInWithEmailAndPassword(credentials.email, credentials.password)
            //   .then(credential=>{
            //     this.context.commit(Mutations.SET_AUTH, credential.user)
            //     resolve()
            //   })
            //   .catch(({message})=>{
            //     this.context.commit(Mutations.SET_ERROR, message)
            //     reject()
            //   })
            ApiService.post("admin", credentials)
                .then(({ data }) => {
                this.context.commit(Mutations.SET_AUTH, data);
                resolve();
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.message);
                reject(response);
            });
        });
    }
    [_g = Actions.LOGOUT]() {
        this.context.commit(Mutations.PURGE_AUTH);
    }
    [_h = Actions.REGISTER](credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("registration", credentials)
                .then(({ data }) => {
                this.context.commit(Mutations.SET_AUTH, data);
                resolve();
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
                reject();
            });
        });
    }
    [_j = Actions.FORGOT_PASSWORD](payload) {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(payload.email)
                // ApiService.post("forgot_password", payload)
                .then(() => {
                //this.context.commit(Mutations.SET_AUTH, data);
                resolve();
            })
                .catch((reason) => {
                this.context.commit(Mutations.SET_ERROR, reason);
                reject();
            });
        });
    }
    [_k = Actions.VERIFY_AUTH]() {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.get("verify")
                .then(({ data }) => {
                this.context.commit(Mutations.SET_AUTH, data);
            })
                .catch((e) => {
                this.context.commit(Mutations.SET_ERROR, e.message);
            });
        }
        else {
            this.context.commit(Mutations.PURGE_AUTH);
        }
    }
    [_l = Actions.UPDATE_USER](payload) {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.post("update_user", payload)
                .then(({ data }) => {
                this.context.commit(Mutations.SET_USER, data);
                resolve();
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _l, null);
AuthModule = __decorate([
    Module
], AuthModule);
export default AuthModule;
